import React from 'react';
import { ImagesService } from '@services/image-service';
import { Lazy, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import clsx from 'clsx';
import { Picture } from '@interfaces/models/picture';
import 'swiper/css/pagination';
import 'swiper/css/lazy';
import useHeroPdpStyles from '@hooks/hero-pdp/use-hero-pdp-styles';
import ProductImage from '@components/atoms/vc-images/components/product-image';
import useWindowSize from '@hooks/use-window-size';
import usePdpLayout from '@hooks/product/use-pdp-layout';
import useFeatureFlag from '@hooks/use-feature-flags';
import styles from './slider.module.scss';

export interface SliderProps {
  pictures?: Picture[];
  clickIMG?: (picture: Picture, index: number) => void;
  productPath: string;
}

const Slider: React.FC<SliderProps> = (props) => {
  const { pictures, clickIMG, productPath } = props;

  const { isWiderThanMd } = useWindowSize();
  const { isHeroPdpStyles } = useHeroPdpStyles();
  const { isSemPDP } = useFeatureFlag();
  const { isRecirculation } = usePdpLayout();

  const onImageClick = (pic: Picture, index: number) => {
    clickIMG(pic, index);
  };

  const getSEOImgPath = (path: string): string => {
    return ImagesService.improveSEOProductPathImg(path, productPath);
  };

  return (
    <Swiper
      className={clsx(
        styles.slider,
        { [styles['slider--heroPdp']]: isHeroPdpStyles },
        {
          [styles['slider--heroPdp--bulletsWidth']]: isHeroPdpStyles && pictures?.length > 15,
        },
        { [styles['slider--semPdpIteration']]: isSemPDP && !isRecirculation },
      )}
      modules={[Pagination, Lazy]}
      slidesPerView={1}
      draggable
      lazy
      pagination={{
        bulletClass: clsx('swiper-pagination-bullet', styles.slider__bullet),
        bulletActiveClass: clsx('swiper-pagination-bullet-active', styles['slider__bullet--active']),
      }}
    >
      {(pictures || []).map((picture: Picture, index: number) => (
        <SwiperSlide
          key={picture.path}
          onClick={() => onImageClick(picture, index)}
          onKeyPress={() => onImageClick(picture, index)}
          className={clsx(styles.image__wrapper, {
            [styles['image__wrapper--heroPdp']]: isHeroPdpStyles,
          })}
        >
          <ProductImage
            className={clsx(styles.image, {
              [styles['image--heroPdp']]: isHeroPdpStyles,
            })}
            src={getSEOImgPath(`/produit/${picture.path}`)}
            width={isSemPDP ? 260 : isHeroPdpStyles ? 160 : 500}
            height={isSemPDP ? 260 : isHeroPdpStyles ? 160 : 500}
            alt={picture?.alt ?? ''}
            disableLazyLoad={index === 0}
            priority={!isWiderThanMd && index === 0}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Slider;
